import { useCallback, useEffect, useMemo } from 'react';
import { civilDateParam, stringParam, useUrlState } from '@/shared/useUrlState';
import type { EnvelopeRange } from './envelopeRange';

const SCHEMA = {
  from: civilDateParam(),
  to: civilDateParam(),
  // The retired presets' params, read only to be removed.
  w: stringParam(),
  wf: stringParam(),
  wt: stringParam(),
};

/**
 * The envelope page's window in the URL (TMM-B6; TMMAPP-0114 A3): `from` / `to` civil dates, the
 * virtual account P&L's form; both omitted for Year to date. A reload, a shared link and Back keep
 * the window; changing it replaces the entry. An old link's `w` / `wf` / `wt` is ignored, so the
 * retired presets read as Year to date, and the fallback's first write strips them by replace
 * (TMMAPP-0117 A5).
 */
export function useEnvelopeRange(): [EnvelopeRange, (next: EnvelopeRange) => void] {
  const [{ from, to, w, wf, wt }, setUrl] = useUrlState(SCHEMA);
  const range = useMemo<EnvelopeRange>(() => ({ from, to }), [from, to]);
  const setRange = useCallback((next: EnvelopeRange) => setUrl(next), [setUrl]);
  const legacy = w !== '' || wf !== '' || wt !== '';
  useEffect(() => {
    if (legacy) setUrl({ w: '', wf: '', wt: '' });
  }, [legacy, setUrl]);
  return [range, setRange];
}
